module.exports = __webpack_public_path__ + "static/media/13.60171d34.JPG";